<template>
    <div>
      <v-app-bar  dense style="
          position: fixed;
          z-index: 9;
          height: 58px;
          top: 0;
          align-content: center;
          left: 0;
        ">
        <div class="boton-sidebar">
          <v-app-bar-nav-icon @click="activeSidebar"></v-app-bar-nav-icon>
        </div>
  
        <v-toolbar-title><div style="display: flex;flex-wrap: wrap;margin-left: 1.2rem;">
          <span style="font-size: .75rem;width: 100%;font-weight: 600;">{{ nombre }}</span>
          <span style="font-weight: 400; font-size: .75rem;width: 100%;">{{ descripCas }}</span>
        </div>
        </v-toolbar-title>
  
        <v-spacer></v-spacer>
  
  
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-badge style="margin-right: 1rem;" v-if="statusNotificacionesClinica" :content="messages" :value="messages"
              color="green" overlap @click="redirectRepCli" v-bind="attrs" v-on="on">
              <v-btn icon @click="redirectRepCli">
                <v-icon medium>
                  mdi-calendar
                </v-icon>
              </v-btn>
            </v-badge>
          </template>
          <span>N° de pacientes que no han asistido a su sesión en las últimas 48 horas.</span>
        </v-tooltip>
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-badge style="margin-right: 1rem;" v-if="statusNotificacionesAdmin" :content="messages" :value="messages"
              color="green" overlap @click="redirectRepAdm" v-bind="attrs" v-on="on">
              <v-btn icon @click="redirectRepAdm">
                <v-icon medium>
                  mdi-calendar
                </v-icon>
              </v-btn>
            </v-badge>
          </template>
          <span>N° de pacientes que no han asistido a su sesión en las últimas 48 horas.</span>
        </v-tooltip>
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="actionPrincipal" v-bind="attrs" v-on="on" style="color: white">
              <v-icon>mdi-home</v-icon>
            </v-btn>
          </template>
          <span>Inicio</span>
        </v-tooltip>
        <!--  Cerrar Sesión -->
        <v-dialog v-model="dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h5"> ¿Cerrar la sesión? </v-card-title>
            <v-card-text>Ud. esta apunto de salir del sistema</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text :dialog="dialog" @click="actionOut">
                Aceptar
              </v-btn>
              <v-btn color="green darken-1" text @click="dialog = false">
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip v-bind="attrs" v-on="on" bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="actionSalir" dark v-bind="attrs" v-on="on" icon>
                  <v-icon dark left>mdi-logout</v-icon>
                </v-btn>
              </template>
              <span>Cerrar sesión</span>
            </v-tooltip>
          </template>
          <v-card>
            <v-card-title class="text-h5"> ¿Cerrar la sesión? </v-card-title>
            <v-card-text>Ud. esta apunto de salir del sistema</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text :dialog="dialog" @click="actionOut">
                Aceptar
              </v-btn>
              <v-btn color="green darken-1" text @click="dialog = false">
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-app-bar>
    </div>
  </template>
  <style scoped src="./style.css">
  </style>
  <script>
  import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        alert: false,
        statusNotificacionesClinica: false,
        statusNotificacionesAdmin: false,
        messages: 0,
        dialog: false,
        perfil: "",
        nombre: "",
        descripCas: "",
      };
    },
    created() {
      this.perfil = sessionStorage.getItem("perfil");
      this.nombre = sessionStorage.getItem("nombre");
      this.descripCas = sessionStorage.getItem("descripCas");
      this.idCas = sessionStorage.getItem("urlCas");
      this.viewNotificaciones();
    },
    methods: {
      ...mapActions(['logout']),
      activeSidebar() {
        this.$emit("activeSidebar");
        console.log("click en el boton");
      },
      actionOut() {
        this.logout();
        sessionStorage.removeItem("url");
        sessionStorage.removeItem("urlCas");
        sessionStorage.removeItem("usuario");
        sessionStorage.removeItem("perfil");
        sessionStorage.removeItem("nombre");
        sessionStorage.removeItem("keyValue");
        sessionStorage.removeItem("descripCas");
        this.dialog = false;
        this.$router.push("/");
      },
      actionPrincipal() {
        var currentUrl = window.location.href;
        if (!currentUrl.includes("/go")) {
          this.$router.push("/go");
        }
      },
      redirectRepCli() {
        var currentUrl = window.location.href;
        if (!currentUrl.includes("CuposIpress")) {
          this.$router.push("/cuposIpress");
        } else {
          this.$emit("redirectRepCli");
        }
      },
      redirectRepAdm() {
        var currentUrl = window.location.href;
        if (!currentUrl.includes("Cupos")) {
          this.$router.push("/cupos");
        } else {
          this.$emit("redirectRepAdm");
        }
  
      },
      actionSalir() {
        this.dialog = true;
      },
      viewNotificaciones() {
        var currentUrl = window.location.href;
        if (currentUrl.includes("Cupos") && !currentUrl.includes("CuposIpress")) {
          this.statusNotificacionesAdmin = true;
        }
        if (currentUrl.includes("CuposIpress")) {
          this.statusNotificacionesClinica = true;
        }
      }
    },
  };
  </script>